import { useAuth } from "@clerk/clerk-react";
import { useEffect, useState } from "react";
import { createApiClient } from "./api";

export default function DisconnectBank() {
  const { getToken } = useAuth();
  const [hasBank, setHasBank] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkStatus() {
      try {
        const api = createApiClient(getToken);
        const res = await api.get("/api/plaid/status");
        setHasBank(res.data.connected);
      } catch (err) {
        console.error("Failed to check bank status", err);
      } finally {
        setLoading(false);
      }
    }

    checkStatus();
  }, [getToken]); // ✅ ESLint satisfied

  // ✅ Guard
  if (loading || !hasBank) {
    return null;
  }

  async function handleDisconnect() {
    if (!window.confirm("Disconnect bank and delete all transactions?")) {
      return;
    }

    try {
      const api = createApiClient(getToken);
      await api.post("/api/plaid/disconnect");
      window.location.reload();
    } catch (err) {
      console.error("Disconnect failed", err);
      alert("Failed to disconnect bank");
    }
  }

  return (
    <button
      onClick={handleDisconnect}
      className="text-sm text-red-600 hover:text-red-700"
    >
      Disconnect Bank
    </button>
  );
}
